import { Navigate } from 'react-router';
import { ROUTE_PATH } from '../constants/route-constants';
import Login from '../pages/login';
import ExploreAuction from '../pages/explore-auction';
import AuctionDetails from '../pages/auction-details';
import MyCars from '../pages/my-cars';
import Orders from '../pages/orders';
import SmartRequirement from '../pages/smart-requirement/index';
import Account from '../pages/account/index';
import Notifications from '../pages/notifications/index';
import TermsConditions from '../pages/terms-conditions';
import Faq from '../pages/faq';
import WatchList from '../pages/watch-list';

export const routesConfig = [
    {
        path: ROUTE_PATH.LOGIN,
        exact: true,
        element: <Login />,
        isPublic: true
    },
    {
        path: ROUTE_PATH.HOME,
        exact: true,
        element: <Navigate to={ROUTE_PATH.EXPLORE} />
    },
    {
        path: ROUTE_PATH.EXPLORE,
        exact: true,
        element: <ExploreAuction />
    },
    {
        path: ROUTE_PATH.DEALER_AUCTION_DETAILS,
        exact: true,
        element: <AuctionDetails />
    },
    {
        path: ROUTE_PATH.MY_CARS,
        exact: true,
        element: <MyCars />
    },
    {
        path: ROUTE_PATH.ORDERS,
        exact: true,
        element: <Orders />
    },
    {
        path: ROUTE_PATH.SMART_REQUIREMENT,
        exact: true,
        element: <SmartRequirement />
    },
    {
        path: ROUTE_PATH.WATCH_LIST,
        exact: true,
        element: <WatchList />
    },
    {
        path: ROUTE_PATH.ACCOUNT,
        exact: true,
        element: <Account />
    },
    {
        path: ROUTE_PATH.NOTIFICATIONS,
        exact: true,
        element: <Notifications />
    },
    {
        path: ROUTE_PATH.TERMS_AND_CONDITIONS,
        exact: true,
        element: <TermsConditions />,
        isPublic: true
    },
    {
        path: ROUTE_PATH.FAQ,
        exact: true,
        element: <Faq />,
        isPublic: true
    },
];